/* components/AccordionHeader.ts

Accordion Header Component

Dispatches even on click to toggle the active class
*/
import { Component, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class AccordionHeader extends ThemeComponent {
    private open: string = '';

    private _onOpenChange = new SimpleEvent<string>();

    public get onOpenChange() {
        return this._onOpenChange.asEvent();
    }

    public changeOpen(open: string) {
        this.open = open;

        // Use the private backing field to dispatch
        this._onOpenChange.dispatch(open);
    }
    init() {
        this.$listen(this, 'click', () => {
            this._onOpenChange.dispatch(this.open);
        });
    }
}
